export const getIsAmazon = () => {
  let url = '';
  if (typeof window === 'undefined') {
    url = '';
  } else {
    url = window.location.href;
  }
  const isAmazon = url.includes('amazon-business');
  return isAmazon;
};
